import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import CircleLoader from '@invitation-homes/styled-ui/lib/components/Loader/CircleLoader';

import { EXPERIMENTS } from '../config';
import { evaluateFeature, flushFeatureEvaluation } from '../services/experimentation';
import { readAssignment, saveAssignment } from '../services/scheduling-journey';
import {
  isTourAvailabilityTreatment,
  TOUR_AVAILABILITY_VARIATION_KEYS,
} from '../services/tour-availability-experiment';

export const EVALUATION_TIMEOUT_MS = 1000;

class ScheduleShowingExperienceGate extends Component {
  state = { loading: true, variationKey: null };

  settled = false;

  unmounted = false;

  timeoutId = null;

  componentDidMount() {
    const stored = readAssignment(this.props.unitId);
    if (stored.valid) {
      this.settle(stored.assignment.variationKey);
      return;
    }

    this.evaluate();
  }

  componentWillUnmount() {
    this.unmounted = true;
    clearTimeout(this.timeoutId);
  }

  isCancelled = () => this.settled || this.unmounted;

  settle = (variationKey) => {
    if (this.isCancelled()) return;

    this.settled = true;
    clearTimeout(this.timeoutId);
    this.setState({ loading: false, variationKey });
  };

  flushControlEvaluation = async (variationKey) => {
    if (variationKey !== EXPERIMENTS.TOUR_AVAILABILITY.variations.control) return;

    clearTimeout(this.timeoutId);
    await flushFeatureEvaluation();
  };

  saveAndSettle = ({ variationKey, journeyId }) => {
    if (this.isCancelled()) return;

    const saved = variationKey && saveAssignment({ unitId: this.props.unitId, variationKey, journeyId });
    this.settle(saved?.valid ? variationKey : null);
  };

  evaluate = async () => {
    const journeyId = uuidv4();
    this.timeoutId = setTimeout(() => this.settle(null), EVALUATION_TIMEOUT_MS);

    const variationKey = await evaluateFeature({
      featureKey: EXPERIMENTS.TOUR_AVAILABILITY.featureKey,
      allowlistedVariationKeys: TOUR_AVAILABILITY_VARIATION_KEYS,
      journeyId,
      isCancelled: this.isCancelled,
    });

    if (this.isCancelled()) return;

    await this.flushControlEvaluation(variationKey);
    this.saveAndSettle({ variationKey, journeyId });
  };

  render() {
    if (this.state.loading) return <CircleLoader size={24} />;
    return isTourAvailabilityTreatment(this.state.variationKey)
      ? this.props.treatment || this.props.control
      : this.props.control;
  }
}

ScheduleShowingExperienceGate.propTypes = {
  unitId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  control: PropTypes.node.isRequired,
  treatment: PropTypes.node,
};

export default ScheduleShowingExperienceGate;
